<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/img-flow-product/table">图片流转产品列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item
              label="Excel文件">
              <img-flow-product-batch-read-excel @change-file="(_) => this.file = _"
                                                 @change="(_) => this.form.data = _"/>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../img-flow-product.rules.js'
import ImgFlowProductBatchReadExcel from '@/views/img-flow-product/components/ImgFlowProductBatchReadExcel'

export default {
  components: {ImgFlowProductBatchReadExcel},
  data () {
    return {
      formRules,
      form: {
        data: [],
      },
      file: null,
    }
  },
  computed: {},
  watch: {},
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      let form = this.getForm()
      request.common('updateBatchImgFlowProductData', form).then(({data}) => {
        let errorIndex = Object.keys(data.errors)
        let errorRows = []
        if (errorIndex.length) {
          // 错误行导出
          for (let index of errorIndex) {
            form.data[index].error_message = data.errors[index]
            errorRows.push(form.data[index])
          }
          this.$export(this.file.name.slice(0, -5) + '-错误行', errorRows, {
            fileHeader: [
              {
                key: 'model_id',
                text: '模型ID',
              },
              {
                key: 'id',
                text: '产品ID',
              },
              {
                key: 'alias',
                text: '产品别名',
              },
              {
                key: 'error_message',
                text: '错误信息',
              },
            ],
          })
          this.$alert('部分数据更新失败，请查看Excel文件错误行', '提示', {type: 'error'}).then(() => {
            this.onLoad()
          })
        } else {
          this.$confirm(this.$route.meta.title + '成功, 是否继续更新？', '提示', {type: 'success'}).then(() => {
            this.$refs.form.resetFields()
          }, () => {
            this.$router.push({path: '/img-flow-product/table/'})
          })
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/img-flow-product/pages/ImgFlowProductBatchForm.vue